import { useDispatch, useSelector } from "react-redux";
import { useCallback } from "react";
import { setValidationError } from "../ducks/validation/validation";
import { getValidationError } from "../ducks/validation/selectors";

export const useValidationError = () => {
  const dispatch = useDispatch();
  const error = useSelector(getValidationError);

  const setError = useCallback(
    (err?: Error | null) => {
      dispatch(setValidationError(err));
    },
    [dispatch, setValidationError], // eslint-disable-line
  );

  return { error, setError } as const;
};
